import { Button } from '@/components/Button';
import { LuExternalLink } from 'react-icons/lu';

interface Props {
  formUrl?: string;
  onGoHome?: () => void;
}

export default function FormCompletionScreen({ formUrl, onGoHome }: Props) {
  const handleGoHome = () => {
    if (onGoHome) {
      onGoHome();
    }
  };

  const handlePreview = () => {
    if (formUrl) {
      window.open(formUrl, '_blank');
    }
  };

  return (
    <div className="flex min-h-[calc(100vh-120px)] items-center justify-center p-6">
      <div className="w-full max-w-[1094px] rounded-md shadow-[0px_0px_12px_0px_rgba(0,0,0,0.2)]">
        <div className="flex h-[684px] flex-col items-center justify-center rounded-b-md">
          <div className="flex flex-col items-center gap-xl">
            {/* イラスト */}
            <div className="relative h-[127px] w-[255px] shrink-0">
              <img
                src="/agent/candidate_forms/tutorial-complete.png"
                alt="エントリーフォーム完成"
                className="block size-full max-w-none object-contain"
              />
            </div>

            {/* テキストコンテンツ */}
            <div className="flex flex-col items-center gap-lg text-center">
              <h1 className="text-2xl leading-[1.4] font-bold text-main">
                エントリーフォームが完成しました！
              </h1>
              <p className="max-w-[356px] text-sm leading-[1.7] font-normal text-main">
                プレビューページに移動して、
                <br />
                完成したエントリーフォームを確認してみましょう！
              </p>
            </div>

            {/* ボタン */}
            <div className="flex gap-xs">
              <Button color="secondary" size="md" onClick={handleGoHome}>
                ホームに移動する
              </Button>
              <Button color="primary" size="md" onClick={handlePreview} disabled={!formUrl}>
                さっそく確認してみる
                <LuExternalLink className="ml-xxs size-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
